module.exports={render:function (){with(this) {
  return _h('div', {
    attrs: {
      "id": "app"
    },
    on: {
      "contextmenu": function($event) {
        $event.preventDefault();
      }
    }
  }, [_h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (about.show),
      expression: "about.show"
    }],
    attrs: {
      "id": "about-mask"
    }
  }, [_h('div', {
    staticClass: "mask-backdrop",
    on: {
      "click": hideAbout
    }
  }), " ", _m(0)]), " ", " ", _h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (renameDialog.show),
      expression: "renameDialog.show"
    }],
    attrs: {
      "id": "dialog-mask"
    }
  }, [_h('div', {
    staticClass: "dialog",
    attrs: {
      "id": "rename-dialog"
    }
  }, [_m(1), " ", _h('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (renameDialog.name),
      expression: "renameDialog.name"
    }],
    attrs: {
      "type": "text",
      "id": "filename"
    },
    domProps: {
      "value": _s(renameDialog.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) return;
        renameDialog.name = $event.target.value
      }
    }
  }), " ", _m(2), " ", _h('div', {
    staticClass: "dialog-btn-group"
  }, [_h('button', {
    staticClass: "dialog-btn",
    attrs: {
      "id": "rename-cancel"
    },
    on: {
      "click": onRenameCancel
    }
  }, ["Cancel"]), " ", _h('button', {
    staticClass: "dialog-btn",
    attrs: {
      "id": "rename-confirm"
    },
    on: {
      "click": onRenameConfirm
    }
  }, ["Confirm"])])])]), " ", _h('tool-bar'), " ", _h('layout'), " ", _h('div', {
    attrs: {
      "id": "footer"
    }
  }, [(ui.mode != 'compile') ? _h('div', {
    staticClass: "footer-text footer-btn",
    class: {
      active: workspace.open
    },
    on: {
      "click": toggleWorkspace
    }
  }, ["Workspace\n    "]) : _e(), " ", _h('div', {
    staticClass: "footer-text footer-btn",
    class: {
      active: console.open
    },
    on: {
      "click": toggleConsole
    }
  }, ["Output\n    "]), " ", (ui.mode == 'compile') ? _h('div', {
    staticClass: "footer-text footer-btn",
    class: {
      active: parseTree.open
    },
    on: {
      "click": toggleParseTree
    }
  }, ["Syntax Tree\n    "]) : _e(), " ", (ui.mode == 'compile') ? _h('div', {
    staticClass: "footer-text footer-btn",
    class: {
      active: symbolTable.open
    },
    on: {
      "click": toggleSymbolTable
    }
  }, ["Symbol Table\n    "]) : _e(), " ", (currentCursorPos) ? _h('div', {
    staticClass: "footer-text",
    attrs: {
      "id": "cursor-position"
    }
  }, [_s(currentCursorPos.line + 1) + ":" + _s(currentCursorPos.ch + 1) + "\n    "]) : _e(), " ", _h('div', {
    staticClass: "footer-text footer-btn",
    class: {
      active: about.show
    },
    attrs: {
      "style": "float: right;margin: 0 1px 0 0;"
    },
    on: {
      "click": toggleAbout
    }
  }, ["About\n    "])])])
}},staticRenderFns: [function (){with(this) {
  return _h('div', {
    staticClass: "dialog",
    attrs: {
      "id": "about-dialog"
    }
  }, [_h('div', {
    staticClass: "dialog-banner"
  }, [_h('h1', [_h('span', {
    staticClass: "glyphicon glyphicon-console"
  }), " Compiler"]), " ", _h('p', ["Presented by ", _h('a', {
    attrs: {
      "href": "https://github.com/SevenOutman",
      "target": "_blank"
    }
  }, ["SevenOutman"]), ". Compiler implemented\n          by ", _h('a', {
    attrs: {
      "href": "https://github.com/ExinCoda",
      "target": "_blank"
    }
  }, ["ExinCoda"]), "."])])])
}},function (){with(this) {
  return _h('p', ["New name:"])
}},function (){with(this) {
  return _h('p', ["File type: .toy"])
}}]}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-c9051204!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
 ** module id = 137
 ** module chunks = 2
 **/